import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

export default function ArticleCard({ article }: { article: Article }) {
  return (
    <article className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden transition-all duration-300 hover:border-primary-200">
      <Link to={`/article/${article.id}`} className="block relative overflow-hidden">
        <div className="aspect-[16/9] overflow-hidden">
          <img
            src={article.coverImage}
            alt={article.title}
            title={`${article.title} - 日本精品一区`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <div className="absolute top-3 left-3">
          <span className="px-2.5 py-1 text-xs font-medium bg-background-50/90 text-foreground-800 rounded-full">
            {article.category}
          </span>
        </div>
      </Link>
      <div className="p-5">
        <div className="flex items-center gap-3 text-xs text-foreground-500 mb-2">
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line"></i>
            {article.publishDate}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line"></i>
            {article.readTime} 分钟阅读
          </span>
        </div>
        <Link to={`/article/${article.id}`} className="block">
          <h3 className="text-base font-semibold text-foreground-900 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
            {article.title}
          </h3>
        </Link>
        <p className="text-sm text-foreground-500 mt-2 line-clamp-2 leading-relaxed">
          {article.excerpt}
        </p>
        <div className="flex flex-wrap items-center gap-2 mt-3">
          {article.tags.slice(0, 3).map((tag) => (
            <span key={tag} className="px-2 py-0.5 text-xs bg-secondary-100 text-secondary-700 rounded-full">
              {tag}
            </span>
          ))}
        </div>
      </div>
    </article>
  );
}